export const shouldFetchAnotherUsersSimplePage = ({
  page,
  totalCount,
  totalPages,
  resultsLength,
  pageSize,
}: {
  page: number;
  totalCount: number;
  totalPages: number;
  resultsLength: number;
  pageSize: number;
}) => {
  if (page === 1 && totalCount === 0) return false;
  if (page >= totalPages || resultsLength === 0 || resultsLength < pageSize) return false;
  return true;
};
